import { render } from "./PastJobs.vue?vue&type=template&id=51ed1d74&scoped=true"
import script from "./PastJobs.js?vue&type=script&lang=js&external"
export * from "./PastJobs.js?vue&type=script&lang=js&external"

import "./PastJobs.scss?vue&type=style&index=0&id=51ed1d74&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ed1d74"]])

export default __exports__